import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import Cropper from 'cropperjs';
import './style.scss'

const CropImage = ({
   imageSrc,
   cropperRef = {},
   aspectRatio = 1 / 1,
   minCropBoxWidth = 20,
   minCropBoxHeight = 20,
   initialAspectRatio,
}) => {
   const imageElementRef = useRef(null);

   useEffect(() => {
      const imageElement = imageElementRef.current
      if(!imageElement) return;

      cropperRef.current = new Cropper(imageElement, {
         aspectRatio,
         scalable: true,
         zoomOnWheel: false,
         zoomOnTouch: false,
         viewMode: 1,
         autoCropArea: 1,
         dragMode: 'move',
         background: false,
         minCropBoxWidth,
         minCropBoxHeight,
         initialAspectRatio,
         cropmove: (e) => {
            const currentWidth = cropperRef.current?.cropBoxData?.width
            if(minCropBoxWidth > currentWidth){
               cropperRef.current?.setCropBoxData({ width: minCropBoxWidth })
               e.preventDefault()
            }
         },
      })

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <img
         src={ imageSrc }
         alt='crop_image'
         ref={ imageElementRef }
         id='cropper_image'
      />
   )
}

CropImage.propTypes = {
   imageSrc: PropTypes.string,
   cropperRef: PropTypes.object,
   aspectRatio: PropTypes.number,
   minCropBoxWidth: PropTypes.number,
   minCropBoxHeight: PropTypes.number,
   initialAspectRatio: PropTypes.number,
}

export default CropImage;
